import styled from 'styled-components'

export const MasterContainer = styled.div`
  height: 100vh;
`
